module.exports = __webpack_public_path__ + "static/qcv_bg.37923c52.jpg";